module.exports = __webpack_public_path__ + "img/product_113.38e155a.webp";